import { render, staticRenderFns } from "./EditFieldShippingFilesContentStatus.vue?vue&type=template&id=72e96820"
import script from "./EditFieldShippingFilesContentStatus.vue?vue&type=script&lang=js"
export * from "./EditFieldShippingFilesContentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports